// Locale-aware date helpers. `lang` should be the active i18next language.

const RELATIVE_UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
  ["year", 31536000],
  ["month", 2592000],
  ["week", 604800],
  ["day", 86400],
  ["hour", 3600],
  ["minute", 60],
];

/** "3h ago" / "3시간 전" — falls back to an absolute date past a week. */
export function fmtRelative(iso: string | undefined, lang = "en"): string {
  if (!iso) return "—";
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return iso;
  const diffSec = (Date.now() - t) / 1000;
  if (diffSec < 45) {
    return new Intl.RelativeTimeFormat(lang, { numeric: "auto" }).format(0, "second").replace("0", "");
  }
  if (diffSec >= 7 * 86400) return fmtDate(iso, lang);
  const rtf = new Intl.RelativeTimeFormat(lang, { numeric: "auto" });
  for (const [unit, secs] of RELATIVE_UNITS) {
    if (diffSec >= secs) return rtf.format(-Math.floor(diffSec / secs), unit);
  }
  return rtf.format(-Math.floor(diffSec), "second");
}

export function fmtDate(iso: string | undefined, lang = "en"): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString(lang, { month: "short", day: "numeric", year: "numeric" });
}
